module.exports = __webpack_public_path__ + "img/write_bac.1ece6a12.png";